module.exports = __webpack_public_path__ + "media/src/images/partners/eu_institute-52f9207c057f471b0f94ea9f40d164f2.jpg";